<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-10 col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <form
                    class="m-3"
                    action=""
                    @submit.prevent="submit"
                >
                    <div
                        class="form-group row"
                        v-show="layerData.length == 0 && parcelData"
                    >
                        <div
                            id="error-message"
                            class="small alert alert-danger w-100"
                            style="display: block; color: rgb(114, 28, 36); background-color: rgb(248, 215, 218); border-color: rgb(245, 198, 203);"
                        >
                            {{ trans.percel_layer_check }}
                        </div>
                    </div>
                    <!-- title -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.title }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="text"
                                class="form-control"
                                maxlength="150"
                                v-model="title"
                            />
                            <span
                                class="text-danger"
                                v-if="errors && errors.title"
                            >{{
                                errors.title[0]
                            }}</span>
                        </div>
                    </div>
                    <hr />
                    <div class="text-muted mb-4">{{ trans.setting_parcel_marker }}</div>
                    <!-- image -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.parcel_marker_image }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <label
                                for="imageFile"
                                role="button"
                            ><img
                                    :src="parcelData ? parcelData.image_url : '/img/no-image.jpg'"
                                    class="icon-size-100"
                                    id="preview-image"
                                /></label>
                            <input
                                type="file"
                                class="form-control-file d-none"
                                id="imageFile"
                                accept="image/*"
                                data-preview="preview-image"
                                data-model="image"
                                @change="uploadImage"
                            />
                            <small class="form-text text-muted">
                                {{ trans.parcel_image_size }}
                            </small>
                            <p
                                class="text-danger"
                                v-if="errors && errors.image"
                            >
                                {{ errors.image[0] }}
                            </p>
                        </div>
                    </div>
                    <!-- zoom range -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.parcel_zoom_range }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-4">
                                    <select
                                        class="form-control"
                                        v-model="fromRange"
                                    >
                                        <option
                                            v-for="(i, iIndex) in 22"
                                            :value="iIndex"
                                            :key="'fromRange-' + iIndex"
                                        >
                                            {{ iIndex }}
                                        </option>
                                    </select>
                                    <span
                                        class="text-danger"
                                        v-if="errors && errors.from_range"
                                    >{{
                                        errors.from_range[0]
                                    }}</span>
                                </div>
                                <div class="col-sm-4">
                                    <select
                                        class="form-control"
                                        v-model="toRange"
                                    >
                                        <option
                                            v-for="(j, jIndex) in 22"
                                            :value="jIndex"
                                            :key="'toRange-' + jIndex"
                                            v-show="jIndex > fromRange"
                                        >
                                            {{ jIndex }}
                                        </option>
                                    </select>
                                    <span
                                        class="text-danger"
                                        v-if="errors && errors.to_range"
                                    >{{
                                        errors.to_range[0]
                                    }}</span>
                                </div>
                            </div>
                            <small class="form-text text-muted">
                                {{ trans.parcel_range }}
                            </small>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.show_in_floor }}</label>
                        <div class="col-sm-9 align-center">
                            <input
                                type="checkbox"
                                class="toggle toggle-primary"
                                v-model="isOnParcel"
                                :checked="isOnParcel"
                            />
                        </div>
                    </div>
                    <div
                        class="form-group row"
                        v-show="isOnParcel"
                    >
                        <label class="col-sm-3 col-form-label">{{ trans.parcel }}</label>
                        <div class="col-sm-7">
                            <select
                                class="form-control"
                                v-model="parentId"
                                @change="floorId = ''"
                            >
                                <option
                                    selected
                                    value=""
                                >Choose...</option>
                                <option
                                    v-for="(item, index) in otherParcels"
                                    :value="item.id"
                                    :key="index"
                                    v-show="!parcelData ? true : (parcelData.id != item.id)"
                                >
                                    {{ item.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div
                        class="form-group row"
                        v-show="isOnParcel"
                    >
                        <label class="col-sm-3 col-form-label">{{ trans.floor }}</label>
                        <div class="col-sm-7">
                            <select
                                class="form-control"
                                v-model="floorId"
                            >
                                <option
                                    selected
                                    value=""
                                >Choose...</option>
                                <option
                                    v-for="(item, index) in layerList[parentId]"
                                    :value="item.id"
                                    :key="index"
                                    v-show="layerList[parentId]"
                                >
                                    {{ item.title }}
                                </option>
                            </select>
                            <span
                                class="text-danger"
                                v-if="errors && errors.floor_id"
                            >{{
                                errors.floor_id[0]
                            }}</span>
                        </div>
                    </div>
                    <div class="form-group row mb-2">
                        <label class="col-sm-3 col-form-label">{{ trans.use_illustration_image }}</label>
                        <div class="col-sm-9 align-center">
                            <input
                                type="checkbox"
                                class="toggle toggle-primary"
                                v-model="use_illustration_image"
                                :checked="use_illustration_image"
                            />
                        </div>
                    </div>
                    <div
                        class="form-group row mb-2"
                        v-show="use_illustration_image"
                    >
                        <div class="col-sm-3"></div>
                        <div class="col-sm-6">
                            <label class="col-form-label">
                                {{ trans.illustration_image }}
                            </label>
                            <input
                                type="file"
                                class="form-control-file"
                                @change="uploadIllustrationImage"
                            >
                            <div class="row my-4">
                                <img
                                    ref="illustrationImage"
                                    :src="defaultIllustrationImage"
                                    style="max-width:200px"
                                />
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.illustration_image"
                                >{{
                                    errors.illustration_image[0]
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="form-group row mb-2"
                        v-show="use_illustration_image"
                    >
                        <div class="col-sm-3"></div>
                        <div class="col-sm-6">
                            <label class="col-form-label">
                                {{ trans.illustration_image_width_size }}
                            </label>
                            <input
                                type="number"
                                min="1"
                                max="100"
                                step="1"
                                class="form-control"
                                v-model="illustration_image_width_size"
                            />
                            <span
                                class="text-danger"
                                v-if="errors && errors.illustration_image_width_size"
                            >{{
                                errors.illustration_image_width_size[0]
                            }}</span>
                        </div>
                    </div>
                    <div
                        class="form-group row"
                        v-show="use_illustration_image"
                    >
                        <div class="col-sm-3"></div>
                        <div class="col-sm-6">
                            <label class="col-form-label">
                                {{ trans.illustration_image_custom_style_css }}
                            </label>
                            <textarea
                                class="form-control"
                                v-model="illustration_image_custom_style_css"
                            ></textarea>
                            <span
                                class="text-danger"
                                v-if="errors && errors.illustration_image_custom_style_css"
                            >{{
                                errors.illustration_image_custom_style_css[0]
                            }}</span>
                        </div>
                    </div>
                    <hr class="my-4">
                    <div class="text-muted mb-4">{{ trans.parcel_setting_ttl }}</div>
                    <!-- Starting Zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">{{ trans.starting_zoom }}</label>
                        <div class="col-sm-3">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                        class="btn btn-secondary"
                                        type="button"
                                        @click="changeZoomLevel(-0.25)"
                                    >
                                        -
                                    </button>
                                    <button
                                        class="btn btn-dark"
                                        type="button"
                                        @click="changeZoomLevel(0.25)"
                                    >
                                        +
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    class="form-control text-center"
                                    :value="zoom_level"
                                    ref="zoomLevel"
                                    disabled
                                />
                                <span
                                    class="text-danger"
                                    v-if="errors && errors.zoom_level"
                                >
                                    {{ errors.zoom_level[0] }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- min zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.min_zoom }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="min_zoom"
                                @change="mySmartMap.setMinZoom($event.target.value);"
                            />
                            <small class="form-text text-muted">
                                {{ trans.percel_min_zoom }}
                            </small>
                            <span
                                class="text-danger"
                                v-if="errors && errors.min_zoom"
                            >{{
                                errors.min_zoom[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- max zoom -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.max_zoom }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                min="0"
                                max="22"
                                step="0.25"
                                v-model.number="max_zoom"
                                @change="mySmartMap.setMaxZoom($event.target.value)"
                            />
                            <span
                                class="text-danger"
                                v-if="errors && errors.max_zoom"
                            >{{
                                errors.max_zoom[0]
                            }}</span>
                            <small class="form-text text-muted">
                                {{ trans.zoom_max_sub }}
                            </small>
                        </div>
                    </div>
                    <!-- coordinates -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.parcel_coordinates }}
                        </label>
                        <div class="col-sm-9 pl-3">
                            <div class="row d-flex">
                                <div class="">
                                    <span> {{ trans.latitude }} </span>
                                    <input
                                        type="number"
                                        min="-90"
                                        max="90"
                                        step="any"
                                        class="form-control"
                                        v-model="lat"
                                        @change="changeCoordinates"
                                    />
                                </div>
                                <div class="ml-2">
                                    <span> {{ trans.longtitude }} </span>
                                    <input
                                        type="number"
                                        min="-180"
                                        max="180"
                                        step="any"
                                        class="form-control"
                                        v-model="lng"
                                        @change="changeCoordinates"
                                    />
                                </div>
                                <button
                                    class="btn btn-outline-primary mt-auto ml-2"
                                    type="button"
                                    :disabled="!lngLatIsValid"
                                    ref="btnApplyCoordinates"
                                    @click="setFlyToForMarker([lng, lat])"
                                >
                                    {{ trans.btn.apply }}
                                </button>
                            </div>
                            <p class="text-danger">
                                <span v-if="!lngLatIsValid && !errors.lng && !errors.lat">Longtitude must be between -180
                                    and 180. Latitude must be
                                    between -90 and 90</span>
                                <span v-else-if="errors && errors.lng">{{ errors.lng[0] }}</span>
                                <span v-else-if="errors && errors.lat">{{ errors.lat[0] }}</span>
                            </p>
                        </div>
                        <div class="col-sm-12 pl-3">
                            <div class="row">
                                <div
                                    id="map"
                                    style="width: 100%; height: 500px"
                                    class="mh-75"
                                    ref="mySmartMap"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <!-- pitch -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.pitch }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                v-model.number="pitch_value"
                                @change="mySmartMap.setPitch($event.target.value)"
                            />
                            <span
                                class="text-danger"
                                v-if="errors && errors.pitch"
                            >{{
                                errors.pitch[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- bearing -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.bearing }} <span class="required-star"></span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                type="number"
                                class="form-control w-25 text-center"
                                v-model.number="bearing_value"
                                @change="mySmartMap.setBearing($event.target.value)"
                            />
                            <span
                                class="text-danger"
                                v-if="errors && errors.bearing"
                            >{{
                                errors.bearing[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- first view floor -->
                    <div
                        class="form-group row"
                        v-show="layerData.length > 0"
                    >
                        <label class="col-sm-3 col-form-label">{{ trans.first_view_layer }}</label>
                        <div class="col-sm-9">
                            <select
                                class="form-control w-25 text-center"
                                v-model="defaultLayerId"
                            >
                                <option
                                    selected
                                    value=""
                                >Choose...</option>
                                <option
                                    v-for="(layer, index) in layerData"
                                    :value="layer.id"
                                    :key="index"
                                >
                                    {{ layer.title }}
                                </option>
                            </select>
                            <span
                                class="text-danger"
                                v-if="errors && errors.default_layer_id"
                            >{{
                                errors.default_layer_id[0]
                            }}</span>
                        </div>
                    </div>
                    <!-- background pattern -->
                    <div class="form-group row">
                        <label class="col-sm-3 col-form-label">
                            {{ trans.background_pattern }}
                        </label>
                        <div class="col-sm-9">
                            <label
                                for="bgPatternFile"
                                role="button"
                            ><img
                                    :src="parcelData && parcelData.background_pattern_url
                                        ? parcelData.background_pattern_url
                                        : '/img/no-image.jpg'
                                        "
                                    class="icon-size-100"
                                    id="preview-bg"
                                /></label>
                            <input
                                type="file"
                                class="form-control-file d-none"
                                id="bgPatternFile"
                                accept="image/*"
                                data-preview="preview-bg"
                                data-model="backgroundPattern"
                                @change="uploadImage"
                            />
                            <span
                                class="align-top text-danger"
                                role="button"
                                @click="removeBackgroundPatternImage"
                                v-if="backgroundPattern"
                            ><i
                                    class="fa fa-minus-circle"
                                    aria-hidden="true"
                                ></i></span>
                                <a href="/img/dl_fileset/background-pattern-set.zip" class="ml-5 btn btn-default btn-sm mr-0"><i class="fas fa-download ml-2"></i>&nbsp;Background Image Set</a>

                            <small class="form-text text-muted">
                                {{ trans.parcel_image_size }}
                            </small>
                            <p
                                class="text-danger"
                                v-if="errors && errors.background_pattern"
                            >
                                {{ errors.background_pattern[0] }}
                            </p>
                        </div>
                    </div>

                    <div class="" id="status">
                        <div class="form-group row mt-3 mb-3">
                            <label class="col-sm-3 col-form-label">
                                {{ trans.status }}
                            </label>
                            <div class="col-sm-9 mt-2">
                                <div class="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="customSwitch1"
                                        v-model="status"
                                    />
                                    <label
                                        class="custom-control-label text-muted"
                                        for="customSwitch1"
                                        >{{ statusTxt }}</label
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- button submit -->
                <button
                    class="btn btn-primary w-25 center mb-4 mt-4 float-right submit-btn"
                    :disabled="isDisabled"
                >
                    {{ parcelData ? trans.btn.update : trans.btn.create }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import MapBox from '../mixins/MapBox/Map';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

export default {
    mixins: [MapBox],
    props: {
        trans: {
            type: Object,
            required: true
        },
        mapData: {
            type: Object,
            required: true
        },
        formAction: {
            type: String,
            required: true
        },
        parcelData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        layerData: {
            type: Array,
            default: function () {
                return [];
            }
        },
        otherParcels: {
            type: Array,
            default: function () {
                return [];
            }
        },
        illustrationImageResource: {
            type: Object,
            default: function () {
                return {};
            }
        },
        hasMarker: {
            type: Boolean,
            default: true
        },
        dragPan: {
            type: Boolean,
            default: true
        },
        draggable: {
            type: Boolean,
            default: true
        },
        isParcelForm: {
            type: Boolean,
            default: true
        },
        adminLang: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            errors: {},
            title: '',
            lng: this.mapData.lng,
            lat: this.mapData.lat,
            fromRange: 0,
            toRange: 21,
            isDisabled: false,
            image: null,
            backgroundPattern: null,
            removeBackgroundPattern: false,
            defaultLayerId: null,
            parentId: '',
            floorId: '',
            isOnParcel: false,
            use_illustration_image: false,
            illustration_image: null,
            illustration_image_width_size: 100,
            illustration_image_custom_style_css: '',
            zoom_level: this.zoomLevel,
            min_zoom: this.minZoom,
            max_zoom: this.maxZoom,
            pitch_value: this.pitch,
            bearing_value: this.bearing,
            status: this.status ? this.status : true,
        };
    },
    computed: {
        lngLatIsValid() {
            return Math.abs(this.lng) <= 180 && Math.abs(this.lat) <= 90;
        },
        layerList() {
            let results = [];
            if (this.otherParcels) {
                this.otherParcels.forEach((element) => {
                    results[element.id] = element.layers;
                });
            }
            return results
        },
        defaultIllustrationImage() {
            return this.parcelData && this.parcelData.illustration_image_id && this.illustrationImageResource
                ? this.illustrationImageResource.image_url
                : '/img/no-image.jpg';
        },
        currentImageries() {
            if (!this.floorId) {
                return [];
            }

            for (let parcel of this.otherParcels) {
                for (let layer of parcel.layers) {
                    if (layer.id == this.floorId) return layer.imageries;
                }
            }
        },
        statusTxt() {
            let status = this.status ? 1 : 0;

            return this.trans.status_val[status];
        },
    },
    methods: {
        initDraw() {
            var self = this;
            this.draw = new MapboxDraw({
                displayControlsDefault: false,
                controls: {
                    polygon: false,
                    trash: false
                },
            });
            this.mySmartMap.addControl(this.draw);
        },
        updateCoordinates(payload) {
            [this.lng, this.lat] = payload;
            this.$refs.btnApplyCoordinates.click();
        },
        changeCoordinates() {
            if (!this.myMarker) {
                this.handleMarker()
            } else {
                this.myMarker.setLngLat([this.lng, this.lat])
            }
        },
        uploadImage(event) {
            if (event.target.files.length == 0) return;

            const file = event.target.files;
            if (!file) return;

            var vModel = event.target.getAttribute('data-model');
            let preview = document.getElementById(event.target.getAttribute('data-preview'));
            var url = URL.createObjectURL(file[0]);
            preview.onload = function () {
                URL.revokeObjectURL(url);
            };
            preview.src = url;
            this[vModel] = file[0];
        },
        removeBackgroundPatternImage() {
            this.backgroundPattern = null;
            this.removeBackgroundPattern = true;
            document.getElementById('preview-bg').src = '/img/no-image.jpg';
        },
        prepareFormData() {
            let formData = new FormData();
            formData.append('title', this.title);
            if (this.image instanceof File) {
                formData.append('image', this.image);
            }
            if (this.backgroundPattern instanceof File) {
                formData.append('background_pattern', this.backgroundPattern);
            }
            formData.append('min_zoom', parseFloat(this.min_zoom));
            formData.append("from_range", this.fromRange);
            formData.append("to_range", this.toRange);
            formData.append('lng', this.lng);
            formData.append('lat', this.lat);
            formData.append('pitch', this.pitch_value);
            formData.append('bearing', this.bearing_value);
            formData.append('default_layer_id', this.defaultLayerId);
            formData.append('max_zoom', parseFloat(this.max_zoom));
            formData.append('zoom_level', parseFloat(this.zoom_level));
            formData.append('floor_id', !this.isOnParcel ? '' : this.floorId);
            formData.append('is_on_parcel', !this.isOnParcel ? 0 : 1);

            formData.append('use_illustration_image', this.use_illustration_image ? 1 : 0);
            if (this.illustration_image instanceof File) {
                formData.append('illustration_image', this.illustration_image);
            }
            formData.append('illustration_image_width_size', this.illustration_image_width_size);
            formData.append('illustration_image_custom_style_css', this.illustration_image_custom_style_css ?? '');

            formData.append('status', !this.status ? 0 : 1);

            if (this.parcelData) {
                formData.append('_method', 'PUT');
                formData.append('remove_background_pattern', this.removeBackgroundPattern ? 1 : 0);
            }

            return formData;
        },
        submit() {
            this.isDisabled = true;
            var self = this;
            axios({
                method: 'POST',
                url: this.formAction,
                data: this.prepareFormData(),
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        toastr['success'](response.data.message);
                        setTimeout(() => {
                            window.location.replace(response.data.redirectTo);
                        }, 2000);
                    }
                })
                .catch((error) => {
                    self.isDisabled = false;
                    if (error.response.status == 422) {
                        this.errors = {};
                        this.errors = error.response.data.errors;
                    }
                });
        },
        fetch() {
            this.title = this.parcelData.title;
            this.min_zoom = this.parcelData.min_zoom;
            [this.fromRange, this.toRange] = this.parcelData.zoom_range;
            [this.lng, this.lat] = this.parcelData.coordinates;
            this.pitch_value = this.parcelData.pitch;
            this.bearing_value = this.parcelData.bearing;
            this.backgroundPattern = this.parcelData.background_pattern_url;
            this.defaultLayerId = this.parcelData.default_layer_id;
            this.max_zoom = this.parcelData.max_zoom;
            this.zoom_level = this.parcelData.zoom_level;
            this.floorId = !this.parcelData.floor_id ? '' : this.parcelData.floor_id;
            this.isOnParcel = !this.parcelData.floor_id ? false : true;
            this.use_illustration_image = !this.parcelData.illustration_image_id ? false : true;
            this.illustration_image = this.parcelData.illustration_image_id && this.illustrationImageResource ? this.illustrationImageResource.image : '';
            this.illustration_image_width_size = this.parcelData.illustration_image_id && this.illustrationImageResource ? this.illustrationImageResource.width_size : '';
            this.illustration_image_custom_style_css = this.parcelData.illustration_image_id && this.illustrationImageResource ? this.illustrationImageResource.custom_style_css : '';
            this.parentId = this.floorId ? this.otherParcels.find(el => el.layers.some(l => l.id == this.floorId)).id : '';
            this.status = !this.parcelData.status ? false : true;
        },
        changeZoomLevel(payload) {
            payload = payload ? this.zoom_level + payload : this.$refs.zoomLevel.value;
            if (payload < 0 || payload > 22) {
                alert('The zoom level can not be less than 0 OR greater 23');
                return;
            }
            this.zoom_level = parseFloat(payload);
            this.currentZoomLevel = parseFloat(payload);
        },
        clickSubmitBtn() {
            var self = this;
            let submitBtns = document.getElementsByClassName('submit-btn');
            if (submitBtns.length > 0) {
                for (let i = 0; i < submitBtns.length; i++) {
                    const btn = submitBtns[i];
                    btn.addEventListener('click', function () {
                        self.submit();
                        this.disabled = true;
                        let formLanguages = document.querySelectorAll(".tab-content form");
                        [...formLanguages].slice(1).forEach(function (form) {
                            var formData = new FormData(form);
                            axios.post(form.action, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            })
                        });
                    });
                }
            }
        },
        uploadIllustrationImage(e) {
            const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
            if (!file.type.match(/.(jpg|jpeg|png|svg\+xml)$/i)) {
                alert('File is invalid, allowed extensions are: jpg, jpeg, png, svg');
                return;
            }

            var self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                self.$refs.illustrationImage.src = e.target.result;
            };
            reader.readAsDataURL(file);
            this.illustration_image = file;
        },
        hideImageries() {
            var self = this;
            var layers = this.mySmartMap.getStyle().layers;

            layers.forEach(function (layer) {
                if (layer.id.startsWith('imagery-source-')) {
                    self.mySmartMap.setLayoutProperty(
                        layer.id,
                        "visibility",
                        "none"
                    );
                }
            });
        },
        loadImageries() {
            var self = this;
            this.currentImageries.forEach((imagery) => {
                const sourceId = "imagery-source-" + imagery.id;
                if (!self.mySmartMap.getSource(sourceId)) {
                    self.mySmartMap.addSource(sourceId, {
                        type: 'image',
                        url: imagery.image_url,
                        coordinates: imagery.coordinates,
                    });
                }
                if (!self.mySmartMap.getLayer(sourceId)) {
                    self.mySmartMap.addLayer({
                        id: sourceId,
                        type: 'raster',
                        source: sourceId,
                        paint: {
                            'raster-fade-duration': 0
                        }
                    });
                } else {
                    self.mySmartMap.setLayoutProperty(sourceId, 'visibility', 'visible');
                }
            });
        }
    },
    created() {
        if (this.parcelData) {
            this.fetch();
        }
    },
    mounted() {
        var self = this;
        this.initDraw();
        this.clickSubmitBtn();
        this.mySmartMap.setZoom(this.min_zoom);
        this.mySmartMap.on('load', function () {
            if (self.adminLang === 'ja') {
                self.switchLanguage(self.adminLang)
            }
            self.loadImageries();
            self.mySmartMap.setZoom(self.zoom_level);
        });
    },
    watch: {
        isOnParcel(newVal) {
            if (!this.mySmartMap || !this.mySmartMap.isStyleLoaded()) {
                return;
            }
            if (!newVal) {
                this.hideImageries();
            } else {
                this.loadImageries();
            }
        },
        currentImageries: {
            deep: true,
            handler: function (newVal, oldVal) {
                if (!this.mySmartMap || !this.mySmartMap.isStyleLoaded()) {
                    return;
                }
                var self = this;
                if (oldVal) {
                    oldVal.forEach(el => {
                        self.mySmartMap.setLayoutProperty(
                            "imagery-source-" + el.id,
                            "visibility",
                            "none"
                        );
                    })
                }

                this.loadImageries();
            }
        }
    }
};
</script>

<style></style>